module.exports = __webpack_public_path__ + "media/images/flags/32/European-Union-48b3f6358a3d3d1966f36eaa58baf4d5.png";